import { getAxios } from "../utils/axios";
export const useInventoryDeleteStorageBin = () => {
    const deleteStorageBin = async (storageId) => {
        await getAxios().delete(`/inventory/storage/${storageId}`);
    };
    return { deleteStorageBin };
};
